/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import * as actions from './action'
import Expend from './component/expend'

class ClubExpend extends React.Component {
  static defaultProps = {
    expendList: {
      list: [],
    },
    period: {
      start_time: moment().format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
  }

  componentWillUnmount() {
    this.props.getPeriod({ start_time: null, end_time: null }) //清除
  }

  render() {
    const { expendList, period } = this.props
    return (
      <Expend
        period={period}
        expendList={expendList}
        fetchSearchExpend={this.props.fetchSearchExpend}
        getPeriod={this.props.getPeriod}
        fetchTimePeriod={this.props.fetchTimePeriod}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    expendList: state.getClubExpend.expendList,
    period: state.getClubExpend.period,
  }
}

export default withRouter(connect(mapStateToProps, actions)(ClubExpend))



// WEBPACK FOOTER //
// ./src/containers/ClubExpend/index.js